import React from 'react';
import { createRoot } from 'react-dom/client'; // Import from "react-dom/client"
import './index.css';
import './assets/icons/icofont/icofont.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { ToastProvider } from './context/ToastContext';

// Use createRoot from "react-dom/client"
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>
);

reportWebVitals();
